import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "phoneNumbersToClickable",
    standalone: true,
})
export class PhoneNumbersToClickablePipe implements PipeTransform {
    public transform(value: string | undefined, linkClass = "link"): string {
        if (!value) {
            return "";
        }

        // NOTE: regex matching examples: +48123123123, +48 123-123-123, (12) 123 12 12, 48426587788
        const phoneRegex = /(\+\d(?:[ -]?\d){7,10}|\(\d{2}\)(?:[ -]?\d){6,9}|(?<![+\d])\d{8,11})(?![ -]?\d|[A-Za-z_])/g;

        return value.replace(phoneRegex, (number) => `<a class="${linkClass}" href="tel:${number}">${number}</a>`);
    }
}
